import { render, staticRenderFns } from "./booleanEditTemplate.vue?vue&type=template&id=4addf138&"
import script from "./booleanEditTemplate.vue?vue&type=script&lang=js&"
export * from "./booleanEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports